const TEXT = {
    APPLY_STEP1_TEXT_1:"公司",
    APPLY_STEP1_TEXT_2:"品牌",
    APPLY_STEP1_TEXT_3:"代理级别",
    APPLY_STEP1_TEXT_4:"申请类别",
    APPLY_STEP1_TEXT_5:"姓名",
    APPLY_STEP1_TEXT_6:"身份证",
    APPLY_STEP1_TEXT_7:"企业执照编号",
    APPLY_STEP1_TEXT_8:"微信号",
    APPLY_STEP1_TEXT_9:"性别",
    APPLY_STEP1_TEXT_10:"出生年月",
    APPLY_STEP1_TEXT_11:"地区",
    APPLY_STEP1_TEXT_12:"手机号",
    APPLY_STEP1_TEXT_13:"验证码",
    APPLY_STEP1_TEXT_14:"密码",
    APPLY_STEP1_TEXT_15:"请输入姓名",
    APPLY_STEP1_TEXT_16:"请输入身份证",
    APPLY_STEP1_TEXT_17:"请输入微信号",
    APPLY_STEP1_TEXT_18:"请输入手机号码",
    APPLY_STEP1_TEXT_19:"请输入验证码",
    APPLY_STEP1_TEXT_20:"请输入密码",
    APPLY_STEP1_TEXT_21:"请再次输入密码",
    APPLY_STEP1_TEXT_22:"请输入企业执照编号",
    APPLY_STEP1_TEXT_23:"请选择",
    APPLY_STEP1_TEXT_24:"提 交",
    APPLY_STEP1_TEXT_25:"男",
    APPLY_STEP1_TEXT_26:"女",
    APPLY_STEP1_TEXT_27:"个人",
    APPLY_STEP1_TEXT_28:"企业",
    APPLY_STEP1_TEXT_29:"确认",
    APPLY_STEP1_TEXT_30:"取消",
    APPLY_STEP1_TEXT_31:"获取验证码",
    APPLY_STEP1_TEXT_32:"获取验证码",
    APPLY_STEP1_TEXT_33:"秒后重新获取",
};
export {
	TEXT
}












// WEBPACK FOOTER //
// ./src/config/page/cn/apply/step1/index.js